<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        message="Select a Cost Center, select a Department name, enter first and last name, enter the email, click save."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },

    methods:{

    },
    watch: {
      async "form_data.cost_center_id"(val) {
        if (val) {
          let http_request = {
            request_id: val,
            department_request: true,
          };
          const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
          if(response.status){
              if (response.data.departments.length) {
                this.array_options.cost_center_department_id = response.data.departments;
                this.form_data.cost_center_department_id = this.array_options.cost_center_department_id[0].id;
              } else {
                this.array_options.cost_center_department_id = [];
                this.form_data.cost_center_department_id = "";
              }
          } else {
               this.error_handling(response)
          }
        }
      }
    },

    mounted(){

    }
    
}
</script>
